<mat-form-field appearance="outline" *im2mLet="{ loading: loading$ | async, page: page$ | async } as data">
    <mat-label>{{ 'FIRMWARE_SEARCH.LABEL' | transloco }}</mat-label>
    <input matInput class="filter-input" [formControl]="fwFilterCtrl" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" (focus)="onFocus(menuTrigger)" required />
    <mat-error *ngIf="fwFilterCtrl.hasError('required')">
        {{ 'FORM_ERRORS.REQUIRED' | transloco }}
    </mat-error>
    <mat-error *ngIf="fwFilterCtrl.hasError('firmware')">
        {{ 'FIRMWARE_SEARCH.NOT_FOUND_ERROR' | transloco }}
    </mat-error>

    <mat-menu #menu class="search-result-list-menu-container">
        <div class="available-user">
            <h3 class="list-title">{{ 'FIRMWARE_SEARCH.AVAILABLE_FIRMWARES' | transloco }}</h3>
            <div class="table-container" (click)="$event.stopPropagation()">
                <liebherr-dialog-loading *ngIf="data?.loading"></liebherr-dialog-loading>
                <table mat-table [dataSource]="dataSource">
                    <ng-container *ngFor="let column of fwColumns" [matColumnDef]="column">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'FIRMWARE_SEARCH.VERSION' | transloco }}
                        </th>
                        <td mat-cell class="selectable" *matCellDef="let element" (click)="onSelection(element, menuTrigger)">
                            {{ element.version || '-' }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="fwColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: fwColumns"></tr>
                </table>
                <liebherr-no-data *ngIf="dataSource.data.length === 0 && !data?.loading"></liebherr-no-data>
            </div>
            <mat-paginator #paginator (click)="$event.stopPropagation()" [pageSizeOptions]="[5]" [pageSize]="5" (page)="onPage($event)" [pageIndex]="data?.page"></mat-paginator>
        </div>
    </mat-menu>
</mat-form-field>
